import { IFileSettings } from 'legacy/lut/library/dragNDrop'

import { IAttachment } from 'clickNgo/models/file'

import { ATTACHMENT_FIELD_NAME, FILE_FORM_ID } from '../../configs'

export const prepareDragNDropAttachments = (filesInfo: IFileSettings[]): IAttachment[] => {
  const fieldName = ATTACHMENT_FIELD_NAME
  const formId = FILE_FORM_ID
  return filesInfo.map((item, index) => {
    // Temporary entryId for new files. After uploading we get new
    const entryId = Date.now() + index
    const link = URL.createObjectURL(item.file)

    return {
      uid: `${entryId}`,
      entryId,
      link,
      fileName: item.file.name,
      fieldName,
      formId,
      file: item.file,
    }
  })
}
